import {create} from "zustand";

const useThemeStore = create((set) => ({
    mode: 'light',
    setMode: (type) => set({mode: type}),
}));
export default useThemeStore;